import React, { useMemo } from 'react'
import { createColumnHelper, getCoreRowModel, useReactTable } from '@tanstack/react-table'
import { Table } from '../OrderDetails/components/Table'
import { useOrderGroupDetailContext } from './context/OrderGroupDetailContext'
import { formatDate } from '../../lib/Util'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { graphql, useFragment } from '../../gql'
import { formatPrice } from '../../components/OrderPrice'
import { getStateForOrderIndex } from './hooks/useSubmitAllOrders'
import { OrderProgressStatus, OrderStatusIndicator } from './components/OrderStatusIndicator'

/*
  Deprecated version of order list, saved for now, but if you read this and it is 2026, maybe it's good idea to delete this :)
*/

export const GroupOrders_OrderGroupFragment = graphql(`
  fragment GroupOrdersTables_OrderGroup on OrderGroup {
    id
    orders {
      id
      reservationNumber
      clearanceItems {
        id
      }
      carrier {
        id
        name
      }
    }
  }
`)

type OrderRow = {
  id: number
  reservationNumber: number
  carrier?: string
  itemsCount: number
  progress?: OrderProgressStatus
}

const columnHelper = createColumnHelper<OrderRow>()

export const GroupOrders: React.FC<{ currentProgress: SubmitGroupProgress | null }> = ({ currentProgress }) => {
  const { orderGroup } = useOrderGroupDetailContext()
  const group = useFragment(GroupOrders_OrderGroupFragment, orderGroup)

  const orders = useMemo(() => {
    if (!group?.orders) return []

    return group.orders.map((order, index) => ({
      id: order.id,
      reservationNumber: order.reservationNumber,
      carrier: order.carrier?.name,
      itemsCount: order.clearanceItems?.length || 0,
      progress: getStateForOrderIndex(currentProgress, index, order.id),
    }))
  }, [group, currentProgress])

  const Columns = useMemo(
    () => [
      columnHelper.accessor('reservationNumber', {
        header: 'Č. obj.',
        size: 80,
        cell: ({ getValue, row }) => (
          <Link
            to={`/order/${row.original.id}?group=${group.id}`}
            className="font-semibold text-primary-blue hover:underline">
            #{getValue()}
          </Link>
        ),
      }),
      // columnHelper.accessor('carrier', {
      //   header: 'Dopravce',
      //   size: 150,
      //   cell: ({ getValue }) => (getValue() ? <div>{getValue()}</div> : <div className="text-gray-500">Nezadáno</div>),
      // }),
      // columnHelper.accessor('itemsCount', {
      //   header: 'Ks.',
      //   size: 40,
      //   cell: ({ getValue }) => <div className="text-center">{getValue()}</div>,
      // }),
      columnHelper.accessor('progress', {
        header: 'Progress',
        size: 100,
        cell: ({ getValue }) => <OrderStatusIndicator status={getValue()} />,
      }),
    ],
    [],
  )

  const table = useReactTable({
    columns: Columns,
    data: orders,
    getCoreRowModel: getCoreRowModel(),
    defaultColumn: {
      // @ts-ignore
      size: '1fr',
    },
  })

  return (
    <div className="h-full flex flex-col">
      <h2 className="text-lg font-semibold mb-4">Objednávky ({orders.length})</h2>
      <div className="flex-1">
        <Table table={table} />
      </div>
    </div>
  )
}
